<!-- <p>dashboard-container works!</p> -->
<div
  [ngClass]="{
  'dashboard-wrapper':  screenSize == ScreenType.Mobile,
}"
>
  <div
    *ngIf="dashboardData.flows.isReports"
    [ngStyle]="{
      'max-width':
        screenSize === ScreenType.Tablet
          ? '1130px'
          : screenSize === ScreenType.Desktop
          ? '1550px'
          : ''
    }"
    [ngClass]="{
      'dashboard-component-container': screenSize == ScreenType.Desktop,
      'dashboard-component-container-tablet': screenSize == ScreenType.Tablet,
      'dashboard-component-container-mobile': screenSize == ScreenType.Mobile
    }"
  >
    <mat-tab-group
      mat-stretch-tabs="false"
      mat-align-tabs="start"
      (selectedTabChange)="onChangeTab($event)"
      ><mat-tab label="INCIDENT" *ngIf="role != 'housekeeping'"
        ><app-incident-dashboard
          [dashboardData]="dashboardData"
        ></app-incident-dashboard
      ></mat-tab>
      <mat-tab label="VISITOR" *ngIf="role != 'housekeeping'">
        <app-visitor-dashboard
          [dashboardData]="dashboardData"
        ></app-visitor-dashboard>
      </mat-tab>
      <mat-tab
        label="COMPLAINTS"
        [disabled]="isDisableFeature"
        [matTooltip]="
          isDisableFeature ? 'Subscribe to avail this feature' : 'COMPLAINTS'
        "
      >
        <div
          *ngIf="
            (!isShowServiceDetails && screenSize == ScreenType.Mobile) ||
            screenSize != ScreenType.Mobile
          "
        >
          <app-complaints-container
            [isIncidentDetailsClosed]="isShowServiceDetails"
            (showServiceDetails)="onShowServiceDetails($event)"
            (verifyIncident)="onVerifyIncident($event)"
            (snoozeIncident)="onSnoozeIncident($event)"
            (getRangeServiceData)="onGetRangeData($event)"
            (getRequestData)="onGetRequestData()"
          ></app-complaints-container>
        </div>

        <div *ngIf="isShowServiceDetails && isComplaint" style="margin: 5px">
          <app-incident-detail
            [complainDetails]="userComplain"
            [incidentDetails]="incidentDetails"
            [OrgAssets]="dashboardData.orgAssetList.assets"
            (closeIncidentDetail)="onCloseIncidentDetail()"
            (snoozeIncident)="onUpdateRequests($event)"
            (verifyIncident)="onVerifyIncident($event)"
            (postIncidentComment)="onPostIncidentComment($event)"
            [orgUser]="dashboardData.orgUserList"
            (onGetUpdatedRequests)="onGetUpdatedRequestData($event)"
          ></app-incident-detail>
        </div>
        <div *ngIf="isShowServiceDetails && false">
          <div
            style="display: flex; justify-content: center; margin: 10px 0 5px 0"
          >
            <app-incidents-timeline-graph-container
              [incidentData]="incidentDetails"
              [orgUsersData]="dashboardData.orgUserList"
              [isGraph]="true"
              (closeIncidentDetail)="onCloseIncidentDetail()"
            ></app-incidents-timeline-graph-container>
          </div>
        </div>
        <div *ngIf="isShowServiceDetails && false">
          <div style="display: flex; justify-content: center; margin-top: 10px">
            <app-incidents-timeline-graph-container
              [incidentData]="incidentDetails"
              [orgUsersData]="dashboardData.orgUserList"
              [isGraph]="false"
              (closeIncidentDetail)="onCloseIncidentDetail()"
              (postIncidentComment)="clickedPostUserComment($event)"
            ></app-incidents-timeline-graph-container>
          </div>
        </div>
      </mat-tab>
      <mat-tab [disabled]="isDisableFeature">
        <ng-template mat-tab-label>
          <span
            matTooltip="{{
              isDisableFeature ? 'Subscribe to avail this feature' : 'CLAIMS'
            }}"
            matTooltipPosition="above"
            style="cursor: pointer"
          >
            CLAIMS
          </span>
        </ng-template>
        <div
          *ngIf="
            (!isShowServiceDetails && screenSize == ScreenType.Mobile) ||
            screenSize != ScreenType.Mobile
          "
        >
          <app-claims-container
            [isIncidentDetailsClosed]="isShowServiceDetails"
            (showServiceDetails)="onShowServiceDetails($event)"
            (verifyIncident)="onVerifyIncident($event)"
            (snoozeIncident)="onSnoozeIncident($event)"
            (getRangeServiceData)="onGetRangeData($event)"
            (getRequestData)="onGetRequestData()"
          ></app-claims-container>
        </div>

        <div *ngIf="isShowServiceDetails && isClaim" style="margin: 5px">
          <app-incident-detail
            [complainDetails]="userComplain"
            [incidentDetails]="incidentDetails"
            [complainDetails]="userComplain"
            [OrgAssets]="dashboardData.orgAssetList.assets"
            (closeIncidentDetail)="onCloseIncidentDetail()"
            (snoozeIncident)="onUpdateRequests($event)"
            (verifyIncident)="onVerifyIncident($event)"
            [orgUser]="dashboardData.orgUserList"
            (postIncidentComment)="onPostIncidentComment($event)"
            (onGetUpdatedRequests)="onGetUpdatedRequestData($event)"
          ></app-incident-detail>
        </div>
        <div *ngIf="isShowServiceDetails && false">
          <div
            style="display: flex; justify-content: center; margin: 10px 0 5px 0"
          >
            <app-incidents-timeline-graph-container
              [incidentData]="incidentDetails"
              [orgUsersData]="dashboardData.orgUserList"
              [isGraph]="true"
              (closeIncidentDetail)="onCloseIncidentDetail()"
            ></app-incidents-timeline-graph-container>
          </div>
        </div>
        <div *ngIf="isShowServiceDetails && false">
          <div style="display: flex; justify-content: center; margin-top: 10px">
            <app-incidents-timeline-graph-container
              [incidentData]="incidentDetails"
              [orgUsersData]="dashboardData.orgUserList"
              [isGraph]="false"
              (closeIncidentDetail)="onCloseIncidentDetail()"
              (postIncidentComment)="clickedPostUserComment($event)"
            ></app-incidents-timeline-graph-container>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="REQUESTS">
        <div
          *ngIf="
            (!isShowServiceDetails && screenSize == ScreenType.Mobile) ||
            screenSize != ScreenType.Mobile
          "
        >
          <app-service-requests-container
            [tabDetail]="'REQUESTS'"
            [isIncidentDetailsClosed]="isShowServiceDetails"
            (showServiceDetails)="onShowServiceDetails($event)"
            (verifyIncident)="onVerifyIncident($event)"
            (snoozeIncident)="onSnoozeIncident($event)"
            (getRangeServiceData)="onGetRangeData($event)"
            (getRequestData)="onGetRequestData()"
          ></app-service-requests-container>
        </div>

        <div *ngIf="isShowServiceDetails && isRequest" style="margin: 5px">
          <app-incident-detail
            [complainDetails]="userComplain"
            [incidentDetails]="incidentDetails"
            [OrgAssets]="dashboardData.orgAssetList.assets"
            (closeIncidentDetail)="onCloseIncidentDetail()"
            (snoozeIncident)="onUpdateRequests($event)"
            (verifyIncident)="onVerifyIncident($event)"
            [orgUser]="dashboardData.orgUserList"
            (postIncidentComment)="onPostIncidentComment($event)"
            (onGetUpdatedRequests)="onGetUpdatedRequestData($event)"
          ></app-incident-detail>
        </div>
        <div *ngIf="isShowServiceDetails && false">
          <div
            style="display: flex; justify-content: center; margin: 10px 0 5px 0"
          >
            <app-incidents-timeline-graph-container
              [incidentData]="incidentDetails"
              [orgUsersData]="dashboardData.orgUserList"
              [isGraph]="true"
              (closeIncidentDetail)="onCloseIncidentDetail()"
            ></app-incidents-timeline-graph-container>
          </div>
        </div>
        <div *ngIf="isShowServiceDetails && false">
          <div style="display: flex; justify-content: center; margin-top: 10px">
            <app-incidents-timeline-graph-container
              [incidentData]="incidentDetails"
              [orgUsersData]="dashboardData.orgUserList"
              [isGraph]="false"
              (closeIncidentDetail)="onCloseIncidentDetail()"
              (postIncidentComment)="clickedPostUserComment($event)"
            ></app-incidents-timeline-graph-container>
          </div>
        </div>
      </mat-tab>
      <mat-tab
        label="REPORTS"
        *ngIf="role != 'security' && role != 'housekeeping'"
      >
        <app-reports-page-data
          [userList]="dashboardData.orgUserList"
          [incident]="dashboardData.incidentDetails.incidentList"
          [visitor]="dashboardData.visitorDetails.visitorList"
          [assets]="dashboardData.orgAssetList.assets"
          (onSubmitRequest)="submitUserRequest()"
          (sendReportsToEmail)="sendReports($event)"
          (onSearchNumberAnpr)="searchNumber($event)"
          [numberFound]="dashboardData.Searchednumber"
          [isNumberFound]="dashboardData.status.isNumberFound"
          [isError]="dashboardData.status.isError"
        ></app-reports-page-data>
      </mat-tab>
    </mat-tab-group>
  </div>
  <div
    *ngIf="!dashboardData.flows.isReports"
    class="dashboard-component-container"
    [ngClass]="{
      'dashboard-component-container': screenSize == ScreenType.Desktop,
      'dashboard-component-container-tablet': screenSize == ScreenType.Tablet,
      'dashboard-component-container-mobile': screenSize == ScreenType.Mobile
    }"
  >
    <!-- <mat-tab-group mat-stretch-tabs="true" mat-align-tabs="start">
    <mat-tab label="User Dashboard">
     
    </mat-tab>
    <br />
    <br />
  </mat-tab-group> -->
    <app-user-dashboard
      [dashboardData]="dashboardData"
      [screenSize]="screenSize"
      (onScheduleVisitor)="clickedScheduleVisitor($event)"
      (onLodgeUserComplaint)="clickedLodgeComplaint($event)"
      (onSendBulkInvitation)="clickedSendBulkInvite($event)"
      (onCreateUserPost)="clickedCreateUserPost($event)"
      (onRefreshUserPost)="clickedRefreshUserPost()"
      (onPostUserComment)="clickedPostUserComment($event)"
      (onPostUserLike)="clickedPostUserLike($event)"
      (onSaveUserReportPost)="clickedSaveUserReportPost($event)"
      (onPreApproveVisitor)="clickedPreApprovedVisitor($event)"
      (onCreateUserPoll)="clickedCreateUserPoll($event)"
      (onSubmitPollResponse)="submitPollResponse($event)"
      (onRemovePreApprovedVisitor)="removePreApprovedVisitor($event)"
      (OnVisitorCheckout)="visitorCheckout($event)"
      (onInitIncidentManualEvent)="createManualEvent()"
      (onInitAddGateEntry)="addGateEntry()"
      (onCreateSecurityCallback)="securityCallback($event)"
      (clickedScanQR)="onClickedScanQR()"
      (updateVisitorDetails)="onUpdateVisitorDetails($event)"
      (onVerifyUserIncident)="onVerifyIncident($event)"
      (clickedAdvancedSOS)="onClickedAdvancedSos()"
      (markAsArrivedVisitor)="onMarkAsArrivedVisitor($event)"
      (clusterPreApprovedVisitor)="onClusterPreApprovedVisitor($event)"
      [showNoticeBoard]="showNoticeBoard"
      (closeNoticeBoard)="showNoticeBoard = false"
      (onSnoozeIncidentDetails)="onSnoozeIncident($event)"
      (clusteredApprovedVisitorArrived)="onMarkMultipleApproved($event)"
      (onLogUserAttendance)="onLogAttendance($event)"
      (isPreverifiedFlow)="onIsPreverifiedFlow($event)"
      (isAumyeCommunityFlow)="onIsAumyeCommunity($event)"
      (isPreverifiedFlow)="onIsPreverifiedFlow($event)"
      (isAumyeCommunityFlow)="onIsAumyeCommunity($event)"
      (onAcceptOrRejectPost)="acceptOrRejectPost($event)"
      (postFlaggedpostAction)="onPostFlaggedpostAction($event)"
    ></app-user-dashboard>
  </div>
  <div></div>
  <br />
  <br />
  <br />
  <br />
  <br />
  <br />
  <br />
  <br />
</div>
<!-- RequestDialog Message -->
<ng-template #RequestDialog>
  <h2 matDialogTitle>Requesting Advanced SoS</h2>
  <mat-dialog-content>
    <div style="display: flex; flex-direction: column; align-items: center">
      <b><i>Fetching your location!</i></b>
      <mat-spinner></mat-spinner>
    </div>
  </mat-dialog-content>
</ng-template>
